module.exports = __webpack_public_path__ + "img/react.a6b2386.png";